import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DeleteDialogComponent } from 'src/app/modules/admin-user/delete-dialog/delete-dialog.component';
import { UserLanguageService } from 'src/app/modules/services/user-language-service/user-language.service';
import {UserDashboardService} from '../../user-dashboard.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-no-test-message',
    templateUrl: './user-no-test-message.component.html',
    styleUrls: ['./user-no-test-message.component.scss'],
    standalone: false
})
export class UserNoTestMessageComponent implements OnInit {

  labels;
  labelsSub: Subscription;
  goToTrainingFunction
  training;

  constructor(
    public dialogRef: MatDialogRef<DeleteDialogComponent>,
    private languageService: UserLanguageService,
    private userDashboarService: UserDashboardService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

  ngOnInit(): void {
    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })

    this.goToTrainingFunction = this.data.goToTrainingFunction;
    this.training = this.data.training;
  }


  onNoClick(): void {
    this.userDashboarService.setTraining(this.training)
    this.router.navigateByUrl('user/dashboard');
    this.dialogRef.close();
   }

}
